// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

/*jshint multistr: true */

M.Template = M.Template || {};

M.Template.ProductDetails = {

  /**
   * Renders the layout picker list.
   *
   * @param {list} layouts - A list of layout names.
   */
  LayoutPicker: '\
  <h6>LAYOUT</h6> \
  <ul class="inline"> \
    <@ _.each(layouts, function(layoutName, idx) { @> \
      <li class="layoutThumb" \
          data-layout-name="<@= M.html.htmlAttributeEscape(layoutName) @>"> \
        <img alt="Layout <@= M.html.htmlAttributeEscape(layoutName) @>" \
          src="<@= M.img_src(\'/static/images/weddingwebsites/layouts/' +
              'wedding_websites_layout_\' + \
              M.html.htmlAttributeEscape(layoutName) + \'.png\') @>" /> \
      </li> \
    <@ }); @> \
  </ul> \
  ',

  /**
   * Renders the wedding website PDP start button.
   */
  WeddingSiteStartButton: '\
  <a class="nextButton button primary h36"> \
    <@ if (hasWeddingSite) { @> \
    <span>&nbsp;switch to this design&nbsp;</span> \
    <@ } else { @> \
    <span>&nbsp;start with this design&nbsp;</span> \
    <@ } @> \
    <img src="<@= M.img_src(\'/static/images/sprite_placeholder.png\') @>" \
      class="sprite buttonArrowIcon" /> \
  </a> \
  ',

  /**
   * Renders a zoomed-in view of the various product photography.
   */
  ZoomDialog: '\
    <div class="productPhotoWrapper grid_9"> \
      <img class="productPhoto" src="<@= imageUrl @>" \
        alt="<@= model.get(\'title\') @>" /> \
      <@ if (model.get(\'accessoryOptions\').length > 0 && \
            model.get(\'showAccessoryControls\')) { @> \
        <@ if (model.get(\'isPythonPDPPanel\')) { @> \
          <div class="addToOrder floatL grid_3"> \
            <div class="floatL"> \
              <h6>ADD TO ORDER</h6> \
              <div class="quantityPickers"></div> \
            </div> \
            <p class="caption floatR" style="display:none;"> \
              Added to your order \
            </p> \
          </div> \
        <@ } @> \
        <div class="floatR"> \
          <a class="button buttonPrimary buttonMedium buttonBuySeparately" \
              href=""> \
            buy separately \
          </a> \
        </div> \
      <@ } @> \
    </div> \
    <div class="grid_2"> \
      <@ if (model.get(\'shapeOptions\').length > 0) { @> \
        <div class="separator separator10"> \
          <div class="shapePicker"></div> \
          <p class="caption">Silhouette&trade; shapes are not available \
            for folded cards.</p> \
        </div> \
      <@ } @> \
      <@ if (model.get(\'colorOptions\').length > 0) { @> \
        <div class="separator separator10"> \
          <div class="colorPicker"></div> \
        </div> \
      <@ } @> \
      <@ if (model.get(\'photoViewOptions\').length > 0) { @> \
        <div class="separator separator10"> \
          <div class="photoViewPicker"></div> \
        </div> \
      <@ } @> \
      <@ if (model.get(\'greetingOptions\').length > 0) { @> \
        <div class="separator separator10"> \
          <div class="greetingPicker"></div> \
        </div> \
      <@ } @> \
      <@ if (model.get(\'accessoryOptions\').length > 0) { @> \
        <div class="separator separator10"> \
          <div class="accessoryPicker"></div> \
        </div> \
      <@ } @> \
    </div> \
  ',

  DieCutIncompatWarningDialog: '\
    <div id="tripleThickDieCutWarning"> \
      <@ if (isThickPaperSelected) { @> \
        <p class="bm"> \
          Our <@= paperName @> paper is too thick for our special shapes. If \
          you\'d prefer a special shape, please hit cancel below and select one \
          of our other premium paper options. \
        </p> \
      <@ } else { @> \
        <p class="bm"> \
          Special shapes are available only for flat cards. If you\'d prefer a special \
          shape, please hit cancel below and select a flat card. \
        </p> \
      <@ } @> \
      <p class="floatR accept"> \
        <a class="button primary h30"> \
      <@ if (isThickPaperSelected) { @> \
          continue with <@= paperName @> Paper \
      <@ } else { @> \
          continue with a folded card \
      <@ } @> \
        </a> \
      </p> \
      <p class="floatR cancel"> \
        <a class="button h30 cancel"> \
          cancel \
        </a> \
      </p> \
    </div>',

  EstimatePanel: _.template('\
    <@ if (model.getDeliveredOn()) { @>\
      <span>\
        Order today by midnight PST with\
        <@= model.get("shipping_method_display_name") @> shipping and receive your\
        order by <@= M.Date.toDisplayString(model.getDeliveredOn()) @>.\
      </span>\
      <span> \
        <a \
            data-instrumented-eventspec="click" \
            data-action="M.GA.TRACK_EVENT_ACTION.DELIVERY_OPTIONS_CLICK" \
            data-instrumented-extrainfo-sku="<@= model.get("line_items")[0].sku @>" \
            class="moreDeliveryOptions instrumentedElement"> \
          See more delivery options. \
        </a> \
      </span>\
    <@ } @>\
   '),

  EnvelopeColorPicker: _.template("<tr>\
    <td class='input'><input\
      id='<@= elemId @>'\
      type='radio'\
      <@ if (selected) { @>\
        checked\
      <@ } @>\
      name='envelopeColorRadio' \
      data-id=<@= envelopeColorOptionId @> \
      value='<@= name @>'/></td>\
    <td class='description'>\
      <span class='type'><label \
      <@ if (selected) { @>\
        class='checked'\
      <@ } @>\
      for='<@= elemId @>'><@= name @></label>\
      </span>&nbsp;&nbsp;<span class='caption'><@= caption @></span></td>\
    <td class='priceDelta'><span class='priceDiff'>+&nbsp;$<@= price @></span></td>\
    </tr>\
  "),

  DieCutPanel: _.template("\
    <tr>\
      <td><span style='font-weight:bold;color:#8e8765;width:92%'><@= name @></span></td>\
      <td class='priceDelta'><span class='priceDiff' style='font-weight:bold'>+&nbsp;$<@= price @></span></td>\
    </tr>\
  "),

  TripleThickPaperDialog: '\
    In addition to DoubleThick paper, we have an even thicker, \
    more luxurious paper called TripleThick&trade;. Would you like to upgrade \
    to TripleThick&trade; paper? \
    <ul class="buttons inline"> \
      <li><a class="button buttonMedium buttonSecondary cancelButton"> \
      no thanks</a></li> \
      <li><a class="button buttonMedium buttonPrimary okButton"> \
      upgrade to TripleThick</a></li> \
    </ul>\
  ',

  InvalidCombinationDialog: '\
<@= this.options.message @> \
<ul class="buttons inline"> \
  <li> \
    <a class="switchButton"> \
      <@= switchMessage @> \
    </a> \
  </li> \
  <li> \
    <a class="button buttonMedium buttonPrimary keepButton"> \
      <@= keepMessage @> \
    </a> \
  </li> \
</ul>\
',

  NoProofMessage: _.template('\
    <p>To ensure the fastest possible turnaround of your order,\
    your order will not include a digital proof. We encourage you to double\
    check your photos, text, shipping information, and shipping method before\
    placing your order.</p>\
  '),

  WeddingProofMessage: _.template('\
    <div style="width: 230px; float: left;">\
      <p>After you place your order, one of our expert design associates will\
        create a free personalized digital proof of your design. Within\
        <@= proofingSLA @> of your order, you will be notified by email that\
        your proof is ready for review. Get more information\
        <a href="http://help2.minted.com/articles/General/About-Proofs" target="_blank">here</a>.\
      </p>\
    </div>\
    <img src="/files/content/professional_designer/allison.jpg" style="float: right;">\
    <div style="clear: both;"></div>\
  '),

  DefaultProofMessage: _.template('\
    <div style="width: 230px; float: left;">\
      <p>After you place your order, one of our professional graphic designers\
        will create a free personalized digital proof of your card. Within\
        <@= proofingSLA @> of your order, you will be notified by email that your\
        proof is ready for your review. You receive one proof per item ordered.\
        Additional proof revisions are available for a fee. Get more information\
        <a href="http://help2.minted.com/articles/General/About-Proofs" target="_blank">here</a>.\
      </p>\
    </div>\
    <img src="/files/content/professional_designer/allison.jpg" style="float: right;">\
    <div style="clear: both;"></div>\
'),

  ViewOption: _.template('\
<ul class="moreViews"">\
  <@ _(viewOptions).each(function(viewOption) { @>\
  <li>\
    <img\
       src="//<@= MINTEDCDN_HTTP_HOST @>/files/mintedProductsImages/<@= brand @>/<@= kind @>/<@= collection @>/<@= sku @>-<@= viewOption.file_photo_code @>_A_TH.jpg"\
       data-view-code="<@= viewOption.id @>"\
       class="altView"/>\
    <br/>\
    <span><@= viewOption.description @></span>\
  </li>\
  <@ }); @>\
</ul>\
'),

  LetterpressPricingMessage: _.template('\
    <p class="caption floatL clearL" style="color:#776F56;"> \
      Pricing reflects the cost of a 1-color design. \
      The design as shown is <@= numColorsInProductPhoto @> \
      colors. \
      <a class="letterpressPricingDialogButton"> \
        <img src="<@= M.img_src(\'/static/images/sprite_placeholder.png\') @>" \
          class="sprite infoIcon" /> \
      </a> \
    </p> \
  '),

  StampPricingMessage: _.template('\
    <p class="caption floatR clearR" style="color:#776F56;"> \
      Stamps are sold in sheets of 20 \
    </p> \
  '),

  ProductOptionsPanel: _.template('\
    <@ if (topNote) { @> \
      <div class="media" style="padding-bottom: 10px"> \
        <p class="separator bm10" style="color: #999"> \
          <span> \
            <@ if (!isDownloadable) { @> \
              <strong> \
                NOTE: \
              </strong> \
            <@ } @> \
            <@= topNote @> \
          </span> \
        </p> \
      </div> \
    <@ } @> \
    <@ if (warning) { @>\
      <div class="media bm10"> \
        <span class="img"> \
          <img src="<@= M.img_src(\'/static/images/sprite_placeholder.png\') @>" \
            class="sprite alertIcon24" /> \
        </span> \
        <p class="bd warning"><@= warning @></p> \
      </div> \
    <@ } @> \
    <@ if (showQuantity) { @> \
      <div id="quantities" class="separator heading dotted"> \
        <h3 class="floatL">Quantity and Options:</h3> \
        <div class="floatR bm5"> \
          <div class="quantityPicker"></div> \
          <@ if (shouldShowEachPrice) { @> \
            <span class="perPiece"> \
              <@= isLetterpress ? "starting at" : "" @> \
              <span class="perPiecePrice"><@= pricePerPiece @></span> ea. \
            </span> \
          <@ } @> \
        </div> \
        <@= pricingMessage @> \
      </div> \
    <@ } @> \
    <@ _(M.Model.ProductDetails.OPTION_ORDER).each(function(option) { \
        if (!optionsAvailable[option]) { return; } \
        else { optionData = M.Model.ProductDetails.OPTIONS[option]; } \
    @> \
      <div id="product-<@= optionData.cssPrefix @>" class="separator dotted"> \
        <@ if (shouldShowHeading) { @> \
          <div class="sectionHeading"> \
            <span><@= (option == M.Model.ProductDetails.OPTION.FORMAT) && isNotebook ? "Interior Options" : optionData.header @>:</span> \
          </div> \
        <@ } @> \
        <div class="<@= optionData.cssPrefix @>Picker"></div> \
          <@ if (optionData.aboutDescription && optionData.trackEventAction && shouldShowPaperDialog && !(optionData.notTBLTBF && isTBLTBFProduct)) { @> \
            <a \
                data-instrumented-eventspec="click" \
                data-action="<@= optionData.trackEventAction @>" \
                data-instrumented-extrainfo-sku="<@= productData.product_sku @>" \
                class="instrumentedElement <@= optionData.cssPrefix @>DialogLink infoLink"> \
              <@= (option == M.Model.ProductDetails.OPTION.FORMAT) && isNotebook ? "about our interior options" : optionData.aboutDescription @> \
            </a> \
          <@ } @> \
      </div> \
    <@ }); @> \
    <@ if (productData.is_digital_invitation) { @> \
      <@ if (productData.cloned_from_sku) { @>                                       \
        <div class="separator dotted">  \
          <img class="diCutPaperIcon" src="<@= M.img_src("static/images/di-icon_paper.png") @>">     \
          <span class="diPaperClone"><b>Looking for paper?</b> There\'s a printed version of this design </span> \
          <a href="/product/<@=productData.cloned_from_sku@>/"> shop paper</a>   \
        </div>  \
      <@ } @>   \
      <div id="Price" class="separator dotted"> <h3 class ="floatL">Pricing: </h3> \
          <span class="diPrice"> \
           FREE for a limited time.  \
           <a class="diLearnMore"> Learn more</a> \
          </span>  \
      </div>  \
    <@ } @> \
    <@ if (accessoryDicts.length) { @> \
      <div id="matching-accessories" class="separator dotted"> \
        <div class="sectionHeading"> \
          <div>Complete your suite with matching \
          <@= M.html.htmlAttributeEscape(accessoryPrefix.toLowerCase()) @>accessories:</div> \
          <div class="caption"> \
            <@ if (thickPaperSelected) { @> \
              <span class="triplethickAccessoryHeadingCaption"> \
                Accessories for <span class="paperName"></span> \
                <@= productData.product_kind_description @> are printed on our \
                Signature Paper. \
              </span> \
            <@ } @> \
          </div> \
        </div> \
        <ul> \
          <@ _(accessoryDicts).each(function(accessory) { @> \
            <li class="<@= accessory.product_sku @>"> \
              <div class="accessoryPrefix"><@= M.html.htmlAttributeEscape(accessoryPrefix) @>\
              <@= accessory.product_kind_description @> </div> \
              <div class="quantityPicker-<@= accessory.product_sku @> floatR"></div> \
            </li> \
          <@ }); @> \
        </ul> \
      </div> \
    <@ } @> \
    <@ if (isWeddingLogoProduct) { @> \
      <div class="fieldWrapper showLogoOption"> \
        <@ if (forceLogo) { @> \
          <input type="checkbox" id="showLogoCheckbox" \
                 name="showLogoCheckbox" checked="checked" /> \
        <@ } else { @> \
          <input type="checkbox" id="showLogoCheckbox" class="legacy-text" name="showLogoCheckbox" /> \
        <@ } @> \
        <label> \
          <@= weddingViralityLabel @> \
        </label> \
      </div> \
    <@ } @> \
    <div id="pricePreview" class="separator dotted"> \
      <span class="value"> \
        Subtotal for \
        <@ if (showQuantity) { @> \
          <span class="currentQuantity"><@= quantity @></span> \
        <@ } @> \
        <@ if (unitName) { @>\
          <@= M.html.htmlAttributeEscape(plural(quantity, unitName, unitName + "s")) @> of \
        <@ } @>\
        <@= M.html.htmlAttributeEscape(productData.product_kind_description) @> \
      </span> \
      <span class="total">$<@= totalPrice @> </span> \
      <@ if (showQuantity && shouldShowEachPrice) { @> \
        <span class="perPiece"> \
          <span class="perPiecePrice"><@= pricePerPiece @></span> ea. \
        </span> \
      <@ } @> \
    </div> \
    <@ if (isExpressServiceAvailable) { @> \
      <div id="personalize-product-section" class="separatedBox separator dotted"> \
      <div> \
    <@ } @> \
    <@= proofHtml @> \
    <@ if (isCustomizable) { @> \
      <a \
        data-instrumented-eventspec="click" \
        data-action="M.GA.TRACK_EVENT_ACTION.PERSONALIZE_CLICK" \
        class="personalizeButton instrumentedElement button btnPersonalize primary h36 floatR \
        <@ if (isPreviewMode) { @> \
          disabled \
        <@ } @> \
      "> \
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;personalize&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; \
        <img src="<@= M.img_src("/static/images/sprite_placeholder.png") @>" \
             class="sprite buttonArrowIcon" /> \
      </a> \
    <@ } else { @> \
      <a class="addToCartButton button btnPersonalize primary h36 floatR \
        <@ if (isPreviewMode) { @> \
          disabled \
        <@ } @> \
      "> \
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;add to cart&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; \
        <img src="<@= M.img_src("/static/images/sprite_placeholder.png") @>" \
             class="sprite buttonArrowIcon" /> \
      </a> \
    <@ } @> \
    <@ if (isExpressServiceAvailable) { @> \
      </div>\
      </div>\
      <br/> \
      <span> \
        <img style="vertical-align:middle" \
             src="/static/images/sprites/search/express_service_icon.png"/>&nbsp; \
        <b>Express Service Available</b></span> \
      <span class="floatR">Save money, get it faster.</span> \
      <br /> \
    <@ } @> \
    <@ if (bottomNote) { @> \
      <div class="clearFix"></div> \
      <p style="color:#776F56;margin:10px 0 0 7px;"> \
        <b>NOTE:</b> <@= bottomNote @> \
      </p> \
    <@ } @> \
')
};
